<template>
	<div>
    

		<el-button type='primary' @click="goEdit">{{$t('app_editpasg')}}</el-button>
		<div class='gPageBorder gTopMg' v-show="true" style=''>
      
      <!-- <p class='gCtColor gPTitle' style=''>{{$t('app_softinfo')}} </p> -->


      <el-row class='gPdTB'>

				<el-col :span='24'>
          <el-form class='gShowLeftForm'  label-position='left' label-width="17%">
              <el-form-item label="APPID" style="width:calc(100% - 10px);">
                {{detail.appid}}
              </el-form-item>
          </el-form>
        </el-col>

        <el-col :span='12'>
          <el-form class='gShowLeftForm' label-position='left' :label-width='labelttw'>
              <el-form-item :label="$t('app_psgname') ">
                {{detail.appname}}
              </el-form-item>
          </el-form>
        </el-col>

        <el-col :span='12'>
          <el-form class='gShowRightForm' label-position='left' :label-width='labelttw'>
              <el-form-item :label="$t('app_distributor')">
                {{detail.merchantName}}
              </el-form-item>
          </el-form>
        </el-col>


        <el-col :span='12'>
          <el-form class='gShowLeftForm' label-position='left' :label-width='labelttw'>
              <el-form-item :label="$t('app_authstat') ">
                
                <tagc :tagobj="{type: 'openAuthType', vl: detail.isauthen + ''}"></tagc>
              </el-form-item>
          </el-form>
        </el-col>

        <el-col :span='12'>
          <el-form class='gShowRightForm' label-position='left' :label-width='labelttw'>
              <el-form-item :label="$t('app_cbackad')">
                {{detail.callbackurl}}
              </el-form-item>
          </el-form>
        </el-col>

        
        <el-col :span='24'>
          <el-form class='gShowLeftForm'  label-position='left' label-width="17%">
              <el-form-item :label="$t('app_bsrqsadwl')" style="width:calc(100% - 10px);">
                <el-tag type='primary' v-for="(item,index) in detail.limitIp" :key="index">{{item}}</el-tag>
              </el-form-item>
          </el-form>
        </el-col>

				<el-col :span='24'>
          <el-form class='gShowLeftForm'  label-position='left' label-width="17%">
              <el-form-item :label="$t('app_appwtls')" style="width:calc(100% - 10px);">
                <el-tag type='primary' v-for="(item,index) in detail.packageName" :key="index">{{item}}</el-tag>
              </el-form-item>
          </el-form>
        </el-col>
        
      </el-row>
 
    </div>
	</div>
</template>

<script>
  import MechanismSelector from '@/components/global/mechanism_selector.vue'
	import axios from 'axios'
  import { baseurl,focusEvent } from '../../api/url'
  import tagc from '@/components/global/tagc'
	export default{
		components: {
      MechanismSelector,tagc
    },
		data () {
			var that = this
			return{
        
				detail: {},
				appid: '',
        loading: false,
        labelttw: "34%"
        
			}
		},
		mounted (){
      
			var appid = this.$getWObj().passageEdit
      if (appid) {
        this.appid = appid
        this.getDetail()
      }
     
		},
		methods:{
			getDetail () {
        this.loading = 1
        this.$passageDetail(this.appid, (res) => { 
          this.loading = 0
          if (res.code === 200) {
            this.detail = res.data
          } else {
            this.$message(res.message)
          }
        }, () => {
          this.loading = 0
          this.$message.error(this.$t('app_rqsError'))
        })
      },
			goEdit () {
				this.$router.push({path: '/openpl/passage/detail/edit'})
			},
			selectChange () {
				
			}
		}
	}
</script>



// WEBPACK FOOTER //
// detail.vue?4b41d2ba